/**
 * 页面标题区 —— 统一页面头部的标题、说明与操作按钮。
 * 说明文字用于承载业务口径（如「本平台不生成凭证」），避免这些关键约束只写在文档里。
 */

import { Space, Typography } from 'antd';

export interface PageHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  extra?: React.ReactNode;
  tags?: React.ReactNode;
}

export function PageHeader({ title, description, extra, tags }: PageHeaderProps): React.ReactElement {
  return (
    <div className="ilc-page-header">
      <div style={{ flex: '1 1 420px', minWidth: 260 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <h1 className="ilc-page-title">{title}</h1>
          {tags}
        </div>
        {description ? (
          <Typography.Paragraph className="ilc-page-desc" style={{ marginBottom: 0 }}>
            {description}
          </Typography.Paragraph>
        ) : null}
      </div>
      {extra ? <Space wrap>{extra}</Space> : null}
    </div>
  );
}

export default PageHeader;
